<div class="desbloqueo-container">
  <div class="section">
    <label class="section-label">Observaciones</label>
    <textarea class="observaciones-input" [value]="$observaciones()" (input)="onObservacionesChange($event)" rows="4"
      placeholder=""></textarea>
  </div>
</div>
<div class="footer-actions">
  <app-button
    text="Desbloquear Prospecto"
    icon="check-circle-outline"
    [disabled]="!$puedeDesbloquear()"
    tooltipWhenDisabled="Llenar Observaciones"
    (click)="onDesbloquear()"
  />
</div>
